import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import swal from "sweetalert";

import bgimage from './../../assets/images/background/barathiyar.jpg';

const UpdateBlog = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('gmail', 'YOUR_TEMPLATE_ID', e.target, 'd9b2e0f5fc72cb94792110e8ff2028f3-us16')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset()
        swal('Good job!', 'form successfuly submmited', "success");
        //alert('form suucessfult submmit');
    };
    return (
        <>

            <div className="inner-action overlay-primary-dark" style={{ backgroundImage: "url(" + bgimage + ")", backgroundSize: "contain", backgroundRepeat: "no-repeat" }}>
                <div className="row inner-content">
                    <div className="col-xl-6 col-lg-9">
                        <div className="section-head ">
                            <div className="mt-3 col-lg-8" style={{ lineHeight: "30px" }}>
                                <p style={{ fontSize: 25 }} className='fw-bolder text-dark'>
                                    சங்கம் வைத்து மொழி (தமிழ்) வளர்த்த பண்பாட்டில் வந்த நாம்,
                                    இடம்பெயர்ந்து வாழ்ந்தாலும் நம் முன்னோர்கள் கூற்றுப்படி
                                    எல்லோரும் ஒன்று கூடி நம் தாய் தமிழையும், தமிழரின்
                                    பண்பாட்டையும் வளர்ப்போம்.
                                </p>
                                <h5 className="fw-bolder text-end ">
                                    -சுப்ரமணிய பாரதியார்
                                </h5>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
export default UpdateBlog;